module.exports = {"130105001":"革新街街道","130105003":"新华路街道","130105004":"宁安街道","130105005":"东焦街道","130105006":"西苑街道","130105007":"合作路街道","130105008":"联盟街道","130105009":"石岗街道","130105010":"五七街道","130105011":"天苑街道","130105012":"北苑街道","130105100":"大郭镇","130105101":"赵陵铺镇","130105201":"西三庄乡","130105202":"杜北乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130105.json
// module id = 59
// module chunks = 0